import { Link } from "react-router-dom";
import styled, { keyframes } from "styled-components";

import Button from "../button/Button";

const Wrapper = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    backdrop-filter: blur(3px);
`;

const animation = keyframes`
    0% {
        transform: translateY(-150%);
    }
    100% { 
        transform: translateY(0);
    }
`;

const Modal = styled.div`
    position: relative;
    width: 600px;
    height: 500px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    top: 50%;
    margin-top: -250px;
    left: 50%;
    margin-left: -300px;
    border: 1px solid white;
    border-radius: 1rem;
    background: linear-gradient(145deg, #cacaca, #f0f0f0);
    box-shadow:  10px 10px 30px #bebebe, -10px -10px 30px #ffffff;
    animation: ${animation} 3s ease-in-out;
`;

const ResultTitle = styled.span`
    font-size: 800%;
    color: ${({winner}) => winner === 'player' ? 'darkgreen' : '#8B0000'};
    text-transform: uppercase;
    text-shadow: -7px 7px 14px #757575,
        7px -7px 14px #ffffff;
`;

const ResultText = styled.span`
    font-size: 200%;
    color: darkslategray;
    margin-top: 0;
`;

const GameResult = ({winner}) => {

    return (
        <Wrapper>
            <Modal>
                <ResultTitle winner={winner}>
                    {winner === 'player' ? 'Victory' : 'Defeat'}
                </ResultTitle>
                <ResultText>
                    {winner === 'player' ? 'Congratulations! You won!' : 'Unfortunately, you lost.'}
                </ResultText>
                <Link to="/">
                    <Button>
                        Play again
                    </Button>
                </Link>
            </Modal>
        </Wrapper>
    );
}

export default GameResult;